module.exports = __webpack_public_path__ + "img/00012.2e2c4737.webp";